// api 값 확인 후 변경 예정
const itemStatus = {
	1: {name: '경매'},
	2: {name: '프리미엄 경매'},
	3: {name: '라이선스'},
	4: {name: '지정가 판매'},
	5: {name: '프리미엄 지정가 판매'},
	6: {name: '공모전 응모'},
	7: {name: '인수대기'},
	8: {name: '프리미엄 인수 대기'},
	9: {name: '판매안함'},
};
const itemCuratorStatus = {
	2: {name: '프리미엄 경매'},
	5: {name: '프리미엄 지정가 판매'},
	8: {name: '프리미엄 인수 대기'},
	9: {name: '판매안함'},
};
const itemCategory = {
	2: {name: '아트'},
	178: {name: '프롬프트'},
	9: {name: '수집품'},
	3: {name: '사진'},
	5: {name: '음악'},
	4: {name: '동영상'},
};
const itemEdition = {
	0: {name: '싱글'},
	1: {name: '에디션'},
};
const itemType = {
	'real': {name: '실물'},
	'digital': {name: '디지털'},
};
const detectionStatus = {
	0: {name: '의뢰취소', explanation: '의뢰 취소 되었습니다.'},
	1: {name: '의뢰', explanation: '심사중입니다.'},
	2: {name: '검토', explanation: '검토중입니다.'},
	3: {name: '준비', explanation: '준비중입니다.'},
	4: {name: '처리', explanation: '처리중입니다.'},
	5: {name: '민형사', explanation: '민형사 소송중입니다.'},
	6: {name: '종결', explanation: '종결되었습니다.'},
};


export {itemStatus, itemType, itemCategory, itemEdition, itemCuratorStatus, detectionStatus};
